module.exports = __webpack_public_path__ + "static/media/email.5602af3d.svg";